import UpdateVoiceFileRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/UpdateVoiceFileRequest";
import AudioFileBaseModel from "@models/audioFileBaseModel";

export default class MeditationAudioViewModel extends AudioFileBaseModel {
    id?: string = '';
    langCode: string = '';
    name: string = '';
    description: string = '';
    isPaid: boolean = false;
    
    constructor(obj?: Partial<MeditationAudioViewModel>) {
        super();
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toServerModel(): UpdateVoiceFileRequest {
        const res = new UpdateVoiceFileRequest({
            Name: this.name,
            Id: this.id,
            IsPaid: this.isPaid,
            Description: this.description,
            Base64Content: this.base64File || null
        });
        return res;
    }
    clone(): MeditationAudioViewModel {        
        return new MeditationAudioViewModel({
            audioFile: this.audioFile,
            id: this.id,
            langCode: this.langCode,
            name: this.name,
            description: this.description,
            base64File: this.base64File,
            audioUrl: this.audioUrl,
            isPaid: this.isPaid
        })
    }
}
